var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#888888;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer36"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.16667,-10,-25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42,32.8c0-1.6-1.5-2.8-3.3-2.8H17.3c-1.8,0-3.3,1.3-3.3,2.8v18.3c0,1.6,1.5,2.8,3.3,2.8h21.4 c1.8,0,3.3-1.3,3.3-2.8V32.8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14286,0,0,1,-42.8571,-25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76,37.7h-2.3l-7,6.7v8l7,6.7H76V37.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.91bc8f78251807ff75aa7d8ce4663074.svg";
export { ForwardRef as ReactComponent };